import { render, staticRenderFns } from "./editorV2.vue?vue&type=template&id=216460c7"
import script from "./editorV2.vue?vue&type=script&lang=js"
export * from "./editorV2.vue?vue&type=script&lang=js"
import style0 from "./editorV2.vue?vue&type=style&index=0&id=216460c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports